import * as d3 from 'd3'

export default {
  methods: {

    chart_Router() {
      this.canvasChart = this.svg
      .append('g')
      .attr('id', 'CHART_GROUP')
      .attr('transform', `translate(0, 0)`)
      .style('font-family', 'roboto').attr('cursor', 'default')

      this.chart.group.forEach((d,i)=> {
        
        let chtData = this.chartData.filter(f=> 
          f[this.chart.groupCode] == d.code && 
          f[this.radio.refCode] == this.current.code &&
          f.CDATE >= this.current.start &&
          f.CDATE <= this.current.end
        )

        this.set_maxValue(chtData) //-----> below
        this.draw_ChartCanvas(d) //-----> draw_ChartCanvas.js
        this.draw_Timeline(chtData, d) //-----> draw_Timeline.js
        this.chart_Controller(chtData, d) //-----> draw_Chart.js
      })


      if (this.sundries) {
        let sunData = this.JQueries.sundriesConfig && this.JQueries.sundriesConfig.SQL ? this.Queries[this.JQueries.sundriesConfig.SQL][0] : this.DataItems[0]
        if(this.sundries.length > 0) this.gmx_Sundries(this.svg, this.sundries, sunData, this.JQueries.sundriesConfig.server)
      }
    },


    set_maxValue(chtDate) {
      // Initial
      this.primary.max = null
      this.primary.axis = null
      this.secondary.max = null
      this.secondary.axis = null


      // Setting Primary
      if(this.primary.maxValue == 0) {
        let maxArray = []
        this.chart.styles.filter(f=> f.type == 'BAR').forEach(s => {
          maxArray.push(d3.max(chtDate, c => c[s.code]))
        })
        this.primary.max = this.gmx_maxBound5(d3.max(maxArray))
      } else {
        this.primary.max = this.gmx_maxBound5(this.primary.maxValue)
      }

      this.primary.axis = d3.scaleLinear()
      .domain([0, this.primary.max])
      .range([0, this.chart.height])
      this.primary.titleX = (this.primary.position=='left') ? -this.primary.padding : this.chart.width + this.primary.padding
      this.primary.axisX = (this.primary.position=='left') ? 0 : this.chart.width


      // Setting secondary
      if(this.secondary.maxValue == 0) {
      let maxArray = []
      this.chart.styles.filter(f=> f.type == 'LINE').forEach(s => {
        maxArray.push(d3.max(chtDate, c => c[s.code]))
      })
      this.secondary.max = this.gmx_maxBound5(d3.max(maxArray))
      } else {
        this.secondary.max = this.gmx_maxBound5(this.secondary.maxValue)
      }
   
      this.secondary.axis = d3.scaleLinear()
      .domain([0, this.secondary.max])
      .range([this.chart.height, 0])
      this.secondary.titleX = (this.secondary.position=='left') ? -this.secondary.padding : this.chart.width + this.secondary.padding
      this.secondary.axisX = (this.secondary.position=='left') ? 0 : this.chart.width

      // console.log(this.primary.max, this.secondary.max)
    },

  }
}
           